import React, {useEffect} from 'react';
import {useStyles} from "./styles/FAQStyle";
import {
    Box,
    TablePagination,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Button,
    Typography
} from "@material-ui/core";
import {ReactComponent as AlignLeftIcon} from '../../../common/images/AlignLeftIcon.svg';
import {ReactComponent as TextFieldDownIcon} from '../../../common/images/TextFieldDownIcon.svg';
import {ReactComponent as TableSortIcon} from '../../../common/images/TableSortIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {DATE_UTIL} from "../../../common/util/date/date.util";
import {useHistory} from "react-router-dom";

function FAQHome(props) {
    const classes = useStyles();
    const history = useHistory();
    const {intl} = props;
    const {faqStore, localeStore} = props;
    const [isDesc, setDesc] = React.useState(false);
    const [isSort, setSort] = React.useState(false);

    useEffect(() => {
        faqStore.getFaqs(localeStore.locale);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localeStore.locale])

    const handleChangePage = (event, newPage) => {
        faqStore.setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        faqStore.setRowsPerPage(event.target.value);
    };

    const handleClickCreatedDateSort = () => {
        setSort(true);
        setDesc(!isDesc);
        if (isDesc) {
            faqStore.setFaqs(faqStore.faqs.sort((a, b) => new Date(a.updatedDatetime) - new Date(b.updatedDatetime)));
        } else {
            faqStore.setFaqs(faqStore.faqs.sort((a, b) => new Date(b.updatedDatetime) - new Date(a.updatedDatetime)));
        }

    };

    const handelClickManage = (faqId) => {
        history.push(`/faq/${faqId}/lang/${localeStore.locale.toUpperCase()}`);
    }

    return (
        <Box className={classes.root}>
            <Box>
                <Box display={"flex"} justifyContent={"flex-end"} className={classes.submitBox}>
                    <Button className={classes.tableButton2}
                            onClick={() => handelClickManage(0)}
                            disableRipple
                    >
                        {intl.formatMessage({id: "written"})}
                    </Button>
                </Box>
                <Box>
                    <TableContainer className={classes.tableBox}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead className={classes.tableHeadStyle}>
                                <TableRow>
                                    <TableCell
                                        align='left'
                                        style={{minWidth: 55}}
                                    >
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{"No"}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 300}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "question"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 500}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "answer"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" onClick={handleClickCreatedDateSort}
                                               style={{minWidth: 200}}>
                                        <Box className={classes.sortButton}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "register_date"})}</Typography>
                                            {isSort ? !isDesc ?
                                                <TableSortIcon style={{transform: 'scaleY(-1)'}}/> :
                                                <TableSortIcon/> : <></>}
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.tableBodyStyle}>
                                {faqStore.faqs.slice(faqStore.page * faqStore.rowsPerPage, faqStore.page * faqStore.rowsPerPage + faqStore.rowsPerPage).map((faq, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row"
                                                   align='center'>{index + (faqStore.page * faqStore.rowsPerPage) + 1}</TableCell>
                                        <TableCell align="left">{faq.question}</TableCell>
                                        <TableCell align="left">{faq.answer}</TableCell>
                                        <TableCell
                                            align="left">{DATE_UTIL.getTimeZoneDate(faq.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                        <TableCell align="center">
                                            <Button className={classes.tableButton} disableRipple
                                                    onClick={() => handelClickManage(faq.faqId)}>{intl.formatMessage({id: "management"})}</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 15, 20]}
                        count={faqStore.faqs?.length}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                        page={faqStore.page}
                        rowsPerPage={faqStore.rowsPerPage}
                        component="div"
                        labelDisplayedRows={({count, page}) => {
                            return <span
                                className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / faqStore.rowsPerPage)}</span>
                        }}
                        SelectProps={{
                            IconComponent: TextFieldDownIcon,
                            MenuProps: {
                                className: classes.selectPopover
                            }
                        }}
                        className={classes.paginationBox}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default inject('groupStore', 'authStore', 'faqStore', 'localeStore')(injectIntl(observer(FAQHome)));
